import React from 'react';
import Hero from './components/Hero'
import Navbar from './components/Navbar';
import About from './components/About';
import Footer from './components/Footer';
import Pricing from './components/Pricing';

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Pricing />
      <Footer />
    </div>
  );
}

export default App;
